module.exports = __webpack_public_path__ + "static/img/buy_team@3x.e5635b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_team@3x.png
// module id = OyP9
// module chunks = 1